/* FORTE · MOTION  — tags reveal targets and flips them in as they enter.
   Runs on the Forte home page and the Forte collection page only (gated in
   theme.liquid). Targets are found by selector so the sections stay untouched;
   siblings in one group get a stagger index. */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  /* [selector, staggered?] — cards stagger across their row; single blocks do not. */
  var GROUPS = [
    ['.fh-hero__card', false],
    ['.fh-hero__cards > *', true],
    ['.fh-ht__card', true],
    ['.fh-lv__panel', false],
    ['.fh-bs__cards > .fh-bs__card', true],
    ['.fh-st__card', true],
    ['.fh-sp__card', false],
    ['.fh-fd__cards > *', true],
    ['.fh-vs__card', true],
    ['.fh-ba__card', true],
    ['.fh-ed__card', true],
    ['.fh-sb__card', false],
    ['.fh-em__card', false],
    ['.fplp-hero__card', false],
    ['.fplp-filters', false],
    ['.fplp-grid__cards > .fh-bs__card', true],
    ['.fplp-collage__media', false],
    ['.fh-pr', false],
    ['.fh-trust', false]
  ];
  var IMGS = '.fh-bs__shot, .fh-ht__shot > img, .fh-st__shot img, .fh-sp__shot img, .fh-vs__shot img, .fh-ed__shot img, .fh-ba__half img, .fplp-hero__img, .fplp-collage__img, .fh-fd__cards img';
  var CARDS = '.fh-bs__card, .fh-ht__card, .fh-st__card, .fh-ed__card, .fh-vs__card, .fh-ba__card, .fh-sp__card, .fplp-collage__media';

  function tag(scope) {
    scope = scope || document;
    GROUPS.forEach(function (g) {
      var els = scope.querySelectorAll(g[0]);
      var i = 0;
      els.forEach(function (el) {
        if (el.hasAttribute('data-fm')) return;
        el.setAttribute('data-fm', '');
        if (g[1]) { el.style.setProperty('--fm-i', String(i % 8)); i++; }
        if (inFrame(el)) reveal(el); else io.observe(el);
      });
    });
    scope.querySelectorAll(IMGS).forEach(function (el) { el.classList.add('fm-img'); });
    scope.querySelectorAll(CARDS).forEach(function (el) { el.classList.add('fm-card'); });
  }

  /* any pixel inside the viewport counts — nothing above the fold waits for a scroll */
  function inFrame(el) {
    var r = el.getBoundingClientRect();
    return r.bottom > 0 && r.top < (window.innerHeight || document.documentElement.clientHeight);
  }
  function reveal(el) {
    el.classList.add('is-in');
    var ms = 1100 + (parseInt(el.style.getPropertyValue('--fm-i') || '0', 10) * 110);
    setTimeout(function () { el.classList.add('fm-done'); }, ms + 50);
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      io.unobserve(en.target);
      reveal(en.target);
    });
  }, { rootMargin: '0px', threshold: 0 });

  function start() {
    document.documentElement.classList.add('fm-ready');
    tag(document);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

  /* cards appended later (collection Load More) get the same treatment */
  var grid = document.querySelector('[data-fplp-cards]');
  if (grid) new MutationObserver(function () { tag(grid.parentNode); }).observe(grid, { childList: true });
  window.FORTE_MOTION_TAG = tag;
})();
